import { useQuery } from '@tanstack/react-query';

import { courseConst, ICourse } from 'modules/courses';
import { $apiV2 } from 'modules/global';

export const getCourse = (slug?: string) => async () => {
  const { data } = await $apiV2.get(`/teacher-course/course-name/${slug}`);

  return { course: data?.data };
};

export const useCourseBySlug = (slug?: string) => {
  const { data, ...args } = useQuery<{ course: ICourse }>({
    queryKey: [courseConst.queryKeys.COURSE_BY_SLUG, slug],
    queryFn: getCourse(slug)
  });

  return { ...data, ...args };
};
